import { Component, OnInit } from '@angular/core';
import { Environment } from 'src/environments/environment';
import { ConsoleService } from './services/functions/console/console.service';
import { DomainService } from './services/functions/domain/domain.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  env: any = Environment;
  debug: string = this.env.app.debug;
  title: string = this.env.app.title;

  constructor(
    public srvConsole: ConsoleService,
    public srvDomain: DomainService,
  ) {}

  ngOnInit(): void {
    this.getDomainData();
  }

  getDomainData() {
    let domainVerify = this.srvDomain.getDomainVerify();
    let mssgVerify = `domainVerify: ${domainVerify}`;
    if (this.debug) {
      this.srvConsole.info(
        false,
        mssgVerify
      );
    }

    let domainInfo = this.srvDomain.getDomainInfo();
    let mssgInfo = `domainInfo: ${domainInfo}`;
    if (this.debug) {
      this.srvConsole.info(
        false,
        mssgInfo
      );
    }
  }
}
